import React from 'react';
import { X } from 'lucide-react';
import { LEGAL_TEMPLATE_NOTE } from '../../config/content';

// Renderiza el cuerpo de un disclaimer (título, intro, cláusulas numeradas y cierre).
export function DisclaimerBody({ disclaimer }) {
  return (
    <div className="text-sm text-gray-700 space-y-4">
      <p className="font-semibold text-gray-900">{disclaimer.title}</p>
      <p>{disclaimer.intro}</p>
      <ol className="list-decimal pl-5 space-y-3">
        {disclaimer.clauses.map((clause, i) => (
          <li key={i}>
            <span className="font-semibold">{clause.heading}</span> {clause.text}
          </li>
        ))}
      </ol>
      <p>{disclaimer.closing}</p>
      <p className="text-xs text-gray-500 italic border-t border-gray-200 pt-3">
        {LEGAL_TEMPLATE_NOTE}
      </p>
    </div>
  );
}

// Modal accesible que muestra el texto completo del disclaimer.
function DisclaimerModal({ open, onClose, disclaimer }) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-xl shadow-2xl max-w-2xl w-full max-h-[85vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
          <h3 className="text-lg font-bold text-gray-900">{disclaimer.title}</h3>
          <button
            type="button"
            onClick={onClose}
            className="text-gray-400 hover:text-gray-700"
            aria-label="Cerrar"
          >
            <X className="h-6 w-6" />
          </button>
        </div>
        <div className="px-6 py-4 overflow-y-auto">
          <DisclaimerBody disclaimer={disclaimer} />
        </div>
        <div className="px-6 py-4 border-t border-gray-200 text-right">
          <button type="button" onClick={onClose} className="btn-primary">
            Entendido
          </button>
        </div>
      </div>
    </div>
  );
}

export default DisclaimerModal;
